import { PackagingDto } from 'src/store/packagings/packaging';
import { ArrayUtils } from 'src/utils/array';
import { PackagingAction, PackagingTypes } from './packagings.actions';

export type PackagingsState = Readonly<{
  packagings: PackagingDto[];
  errors: any;
}>;

const initialState: PackagingsState = {
  packagings: [],
  errors: null
};

const packagingsReducer = (
  state: PackagingsState = initialState,
  action: PackagingAction
) => {
  switch (action.type) {
    case PackagingTypes.FetchAll:
      return { ...state, packagings: action.packagings };
    case PackagingTypes.Add:
      return { ...state, packagings: [...state.packagings, action.packaging] };
    case PackagingTypes.Update:
      return {
        ...state,
        packagings: ArrayUtils.updateListById(
          state.packagings,
          action.packaging
        )
      };
    case PackagingTypes.Delete:
      return {
        ...state,
        packaging: null,
        packagings: ArrayUtils.deleteFromListById(
          state.packagings,
          action.packaging
        )
      };
    case PackagingTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default packagingsReducer;
